import React, { useState } from "react";
import PopupWrapper from "../../../../components/PopupWrapper";
import FormBox from "../../../../components/FormBox/FormBox";
import { OTPInputComponent } from "../../../Login/LoginComp";
import { LoadingButton } from "../../../../Utils/CustomComponent";
import { useForm } from "react-hook-form";
import { addPaymentAccountSchema } from "../../../../Utils/formOptions";

const AddAccountModal = ({ show, setShow }) => {
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [promptFail, setPromptFail] = useState(null);
  const [otpEntered, setOtpEntered] = useState("");
  const [isOtpStage, setIsOtpStage] = useState(false);
  const [afterOtpLoading, setAfterOtpLoading] = useState(false);
  const [disableFWS, setDisableFWS] = useState(false);
  const [otpReceived, setOtpReceived] = useState("");

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm({...addPaymentAccountSchema});

  function handleClose() {
    setShow(false);
    reset();
  }

  function handleOtp() {}

  function onSubmit() {}

  return (
    <PopupWrapper
      title="Add Bank Account"
      extraClass="width-800"
      titleClassName="px-5"
      Component={
        <div>
          <form>
            <FormBox
              options={addAccountArr}
              register={register}
              watch={watch}
              setValue={setValue}
              errors={errors}
            />

            <div className="form-outline mb-1">
              {showOtpInput && (
                <>
                  <OTPInputComponent
                    setOtpEntered={setOtpEntered}
                    setOtpReceived={setOtpReceived}
                    onClick={() => handleOtp()}
                    requestFromCHPayment={true}
                  />
                </>
              )}
            </div>

            <div className="text-center pt-1 mt-5 mb-5 pb-1">
              {showOtpInput ? (
                <LoadingButton
                  className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
                  type="button"
                  onClick={handleSubmit(onSubmit)}
                  title={"Verify OTP and Continue"}
                  disabled={afterOtpLoading}
                  loading={afterOtpLoading}
                />
              ) : (
                <LoadingButton
                  className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
                  type="button"
                  onClick={handleSubmit(onSubmit)}
                  disabled={disableFWS}
                  loading={disableFWS}
                  title={"Continue"}
                />
              )}

              {promptFail && (
                <div className="alert alert-error" role="alert">
                  {promptFail}
                </div>
              )}
              <br />
            </div>
          </form>
        </div>
      }
      toShow={show}
      closeEventHandler={handleClose}
      backdrop="static"
    />
  );
};

export default AddAccountModal;

const addAccountArr = [
  {
    title: "Name on Bank Account *",
    field: "bankAccountName",
    type: "text",
  },
  {
    title: "Bank Name",
    field: "bankName",
    type: "text",
  },
  {
    title: "Account Type",
    field: "accountType",
    type: "select",
    options: [
      { label: "Checking", value: "0" },
      { label: "Savings", value: "1" },
    ],
  },
  {
    title: "Your Street Address as on your Bank Account",
    field: "address",
    type: "textarea",
  },
  {
    title: "Your City, State, Zip as on your Bank Account",
    field: "cityStateZip",
    type: "textarea",
  },
  {
    title: "Routing Number *",
    field: "routingNumber",
    type: "number",
  },
  {
    title: "Account Number *",
    field: "accountNumber",
    type: "number",
  },
  {
    title: "Verify Account Number *",
    field: "verifyAccountNumber",
    type: "number",
  },
  {
    title: "Account Nickame",
    field: "accountNickname",
    type: "text",
  },
];
